/** Client for the chase log: who chased a late interim payment or unanswered variation, and when. */

import { API_BASE, getAuthHeaders } from '../utils/supabase/client';
import type { InterimChaseEvent } from '../types/interimChase';

// The type lives in types/interimChase so pure modules can use it without
// importing this service; re-exported for existing imports.
export type { InterimChaseEvent } from '../types/interimChase';

export async function listProjectChases(projectId: string): Promise<InterimChaseEvent[]> {
  const response = await fetch(`${API_BASE}/interim-chase-events/by-project/${encodeURIComponent(projectId)}`, {
    headers: await getAuthHeaders(),
  });
  if (!response.ok) throw new Error(`Could not load the chase log (${response.status})`);
  const body = (await response.json()) as { events?: InterimChaseEvent[] };
  return body.events ?? [];
}

export async function markChased(
  applicationId: string,
  chase: { kind: 'payment' } | { kind: 'variation'; variationId: string },
  note?: string,
): Promise<InterimChaseEvent> {
  const headers = await getAuthHeaders();
  const response = await fetch(`${API_BASE}/interim-applications/${encodeURIComponent(applicationId)}/chase`, {
    method: 'POST',
    headers: { ...headers, 'Content-Type': 'application/json' },
    body: JSON.stringify(note ? { ...chase, note } : chase),
  });
  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as { error?: string } | null;
    throw new Error(body?.error ?? `Could not log the chase (${response.status})`);
  }
  return (await response.json()) as InterimChaseEvent;
}
